// Inline VetraHub logo lockups. Imported via CRA's SVGR (`ReactComponent`) so the SVG renders
// inline in the DOM and the wordmark uses the page's globally-loaded Cabinet Grotesk font —
// unlike an <img src> SVG, which runs in secure static mode and can't load web fonts.
//
// Use <Logo /> on light surfaces, <LogoDark /> on dark surfaces. The standalone public/ SVG
// files remain for emails/docs/favicon where inline rendering isn't possible.
import { ReactComponent as LightLogo } from "../assets/vetrahub-logo.svg";
import { ReactComponent as DarkLogo } from "../assets/vetrahub-logo-dark.svg";
import { ReactComponent as CandidateLogo } from "../assets/vetrahub-logo-candidate.svg";
import { ReactComponent as CandidateDarkLogo } from "../assets/vetrahub-logo-candidate-dark.svg";
import { ReactComponent as BareLogo } from "../assets/vetrahub-logo-bare.svg";

// Employer lockups (tagline: "Screen smarter. Hire better.") — use on /companies + solutions pages.
export function Logo({ className = "h-10 w-auto" }) {
  return <LightLogo className={className} role="img" aria-label="VetraHub" />;
}

export function LogoDark({ className = "h-10 w-auto" }) {
  return <DarkLogo className={className} role="img" aria-label="VetraHub" />;
}

// Candidate lockups (tagline: "Practice smarter. Land the offer.") — use on candidate-facing pages.
export function LogoCandidate({ className = "h-10 w-auto" }) {
  return <CandidateLogo className={className} role="img" aria-label="VetraHub" />;
}

export function LogoCandidateDark({ className = "h-10 w-auto" }) {
  return <CandidateDarkLogo className={className} role="img" aria-label="VetraHub" />;
}

// Tagline-free lockup — use in shared chrome (global Navbar) where the audience is mixed.
export function LogoBare({ className = "h-10 w-auto" }) {
  return <BareLogo className={className} role="img" aria-label="VetraHub" />;
}
